import * as appActions from './app/AppActions';
import * as funnelActions from './funnel/FunnelActions';
import * as paymentsActions from './payments/PaymentsActions';

export const actions = {
  app: appActions,
  funnel: funnelActions,
  payments: paymentsActions,
};
